/**
 * アイコン
 */
export const IconMaster = [
  'home',
  'apartment',
  'group',
  'child_friendly',
  'airplanemode_active',
  'chair',
  'coffee',
  'beach_access',
  'airline_seat_recline_normal',
  'event_seat',
  'work_off',
  'wb_sunny',
  'brightness_3',
  'currency_yen',
  'sick',
  'co_present',
  'group_work',
  'groups3',
  'science',
  'restaurant',
  'cake',
  'phone_disabled',
] as const;

export type IconMasterType = typeof IconMaster[number];
